import { render, staticRenderFns } from "./AccessDenied.vue?vue&type=template&id=3301bd08&scoped=true&"
import script from "./AccessDenied.vue?vue&type=script&lang=ts&"
export * from "./AccessDenied.vue?vue&type=script&lang=ts&"
import style0 from "./AccessDenied.vue?vue&type=style&index=0&id=3301bd08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3301bd08",
  null
  
)

export default component.exports